import _ from "lodash";
import React, { ReactElement, useMemo, useState } from "react";
import Select from "react-select";
import { Opportunity, OpportunityService } from ".";
import { Loading } from "../ui";

interface IProps {
	accountId: string;
	handleChange: (selectedOpportunity: any, actionType: any) => any;
	defaultValue: any;
	isMulti?: boolean;
	returnModels?: boolean;
	budgetId?: number | null;
}

export const OpportunitesForAccountSelect = (props: IProps): ReactElement => {
	const [opportunities, setOpportunities] = useState<Opportunity[]>();

	const opportunityService = new OpportunityService();

	useMemo(() => {
		const fetchOpportunities = async () => {
			const opportunityData = await opportunityService.findByAccount(
				props.accountId,
				props.budgetId,
			);
			setOpportunities(opportunityData);
		};

		fetchOpportunities();
	}, []);

	if (!opportunities) {
		return <Loading />;
	}

	if (opportunities.length === 0) {
		return <span>No Opportunities Available </span>;
	}

	// Opportunities already paying towards another budget are listed but
	// disabled, rather than hidden, so it's clear where they went. They sort to
	// the end so the ones that can be picked come first.
	const options = _.sortBy(
		opportunities.map((opportunity: Opportunity) => {
			const otherBudget = opportunity.assignedBudgetName;

			return {
				value: opportunity.id,
				label: otherBudget
					? `${opportunity.name} (on ${otherBudget})`
					: opportunity.name,
				isDisabled: !!opportunity.assignedBudgetId,
			};
		}),
		option => option.isDisabled,
	);

	return (
		<Select
			{...props}
			options={options}
			onChange={(selectedOpportunity: any, actionType: any) => {
				let selected = selectedOpportunity;
				if (props.returnModels) {
					const oppIds = selected.map((opp: any) => {
						return opp.value;
					});

					selected = opportunities.filter((opp: Opportunity) => {
						return _.includes(oppIds, opp.id);
					});
				}

				props.handleChange(selected, actionType);
			}}
		/>
	);
};
